//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"Center",0,0],[0,"Length",1,0],[0,"ToBeDeleted",1,0]],[[["newCenter"],"MoveToPoint",{},1,0],[["lengthDelta","widthDelta"],"MoveDelta",{},2,0],[[],"Split",{R_:{newFillStrip:"Weld.WeldFillStripBuilder"}},0,0],[["lengthDelta"],"StretchPositive",{},1,0],[["lengthDelta"],"StretchNegative",{},1,0],[["alignStrip"],"AlignPositive",{},1,0],[["alignStrip"],"AlignNegative",{},1,0],[["joinStrip"],"JoinPositive",{},1,0],[["joinStrip"],"JoinNegative",{},1,0]],[]];
SPLM.Weld.WeldFillStripBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.WeldFillStripBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;